export function PageHeader() {
    return (
        <div>
            <header>
                <p>Bonk Bot Webapp</p>
            </header>
        </div>
    )
}